import { Expose } from "class-transformer";

export class CreateReturnDeliveryNoteLineDto {
  @Expose()
  id: string;

  @Expose()
  quantity: number;
}
